import React from 'react';

import { Box, IconButton, makeStyles } from '@material-ui/core';
import { Search } from '@material-ui/icons';

import PesquisarMensagensContainer from './PesquisarMensagensContainer';

const useStyles = makeStyles(({ palette, spacing }) => ({
  searchButton: {
    position: 'absolute',
    top: spacing(6),
    right: spacing(1),
    backgroundColor: palette.background.paper,
    zIndex: 2,

    '&:hover': {
      backgroundColor: palette.background.tertiary,
    },
  },
  searchDrawerWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 10,
    pointerEvents: 'none',

    '& > *': {
      pointerEvents: 'auto',
    },
  },
}));

interface ModalSearchDrawerProps {
  atendimento: {
    id: string;
    contato?: { id: string; nome: string };
    contact?: { id: string; name: string };
    canal?: { codigo?: string };
    channel?: { codigo?: string; id?: string; name?: string };
  };
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
  onSelectMessage?: (messageId: string, afterCursor: string) => void;
  onSearchChange?: (value: string) => void;
  hideButton?: boolean;
}

export default function ModalSearchDrawer({
  atendimento,
  open,
  onOpen,
  onClose,
  onSelectMessage,
  onSearchChange,
  hideButton = false,
}: ModalSearchDrawerProps) {
  const classes = useStyles();

  return (
    <>
      {!hideButton && (
        <IconButton
          size="small"
          className={classes.searchButton}
          onClick={onOpen}
          title="Pesquisar mensagens"
        >
          <Search />
        </IconButton>
      )}

      <Box className={classes.searchDrawerWrapper}>
        <PesquisarMensagensContainer
          atendimento={atendimento}
          pesquisarMensagens={open}
          setPesquisarMensagens={onClose}
          onSelectMessage={onSelectMessage}
          onSearchChange={onSearchChange}
        />
      </Box>
    </>
  );
}
